import React, { useState, useEffect } from "react";
import { Table, Icon, Input, Button } from "semantic-ui-react";
import { Tooltip } from "react-tooltip";
import ExcelJS from "exceljs"; // Importa la librería ExcelJS
import { saveAs } from "file-saver";
import axios from "axios";
import { useAuth } from "../../../hook/userAuth";
import { BASE_API } from "../../../ruta-server/BaseApi";
import { toast } from "react-toastify";

export function TableAlumnos(props) {
  const { grupo, alumnos, bajaTemporalAlumno, updateAlumno, datosGrupo } =
    props;
  const itemsPerPage = 20;
  const [currentPage, setCurrentPage] = useState(1);
  const [searchText, setSearchText] = useState("");
  const [realTimeSearch, setRealTimeSearch] = useState("");
  const [alumnoSearch, setAlumnoSearch] = useState("");
  const [rowIndex, setRowIndex] = useState(1); // Estado para el índice acumulativo
  const { auth } = useAuth();

  // Ordenar los alumnos por apellido paterno
  const alumnosOrdenados = [...alumnos].sort((a, b) =>
    a.apellido_paterno.localeCompare(b.apellido_paterno)
  );

  useEffect(() => {
    setSearchText(searchText.toLowerCase());
    setAlumnoSearch(alumnoSearch.toLowerCase());
  }, [searchText, alumnoSearch]);

  const handleRealTimeSearchChange = (value) => {
    setRealTimeSearch(value);
    setCurrentPage(1);
  };

  const filteredAlumnos = () => {
    return alumnosOrdenados.filter(
      (alumno) =>
        alumno.nombre.toLowerCase().includes(realTimeSearch) &&
        alumno.apellido_paterno.toLowerCase().includes(alumnoSearch)
    );
  };

  useEffect(() => {
    const lastPage = Math.ceil(filteredAlumnos().length / itemsPerPage);
    if (currentPage > lastPage) {
      setCurrentPage(lastPage);
    }
    // eslint-disable-next-line
  }, [alumnos, currentPage, searchText, alumnoSearch]);

  const paginatedAlumnos = filteredAlumnos().slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
    // Calcular el nuevo índice acumulativo
    const newIndex = (pageNumber - 1) * itemsPerPage + 1;
    setRowIndex(newIndex);
  };

  const generateListaGrupo = async () => {
    try {
      const excelTemplateResponse = await axios.get(
        `${BASE_API}/api/lista-grupo-template/`,
        {
          responseType: "arraybuffer",
          headers: {
            Authorization: `Bearer ${auth.token}`,
          },
        }
      );
      const excelData = excelTemplateResponse.data;

      // Crear un nuevo libro de Excel
      const workbook = new ExcelJS.Workbook();
      await workbook.xlsx.load(excelData);

      // Obtener la hoja de trabajo
      const worksheet = workbook.getWorksheet("lista_grupo");

      // Crear un nuevo arreglo de nombres
      const nombresAlumnos = alumnosOrdenados.map((alumno) =>
        `${alumno.apellido_paterno} ${alumno.apellido_materno} ${alumno.nombre}`.toUpperCase()
      );

      // Asignar datos de grupo y periodo
      worksheet.getCell("AG1").value = datosGrupo.numero_grupo;

      // Asignar grado y semestre
      const grupo = parseInt(datosGrupo.numero_grupo, 10);
      if (grupo >= 100 && grupo < 200) {
        worksheet.getCell("H1").value = "1°";
        worksheet.getCell("R1").value = "I-II";
      } else if (grupo >= 200 && grupo < 300) {
        worksheet.getCell("H1").value = "2°";
        worksheet.getCell("R1").value = "III-IV";
      } else if (grupo >= 300 && grupo < 400) {
        worksheet.getCell("H1").value = "3°";
        worksheet.getCell("R1").value = "V-VI";
      } else if (grupo >= 400) {
        worksheet.getCell("H1").value = "4°";
        worksheet.getCell("R1").value = "VII-VIII";
      }

      // Llenar las celdas desde B5 hasta B36 con los nombres de los alumnos
      const startRow = 5;
      const endRow = 35;
      for (let i = startRow; i <= endRow; i++) {
        const cell = worksheet.getCell(`B${i}`);
        const alumnoIndex = i - startRow;
        cell.value = nombresAlumnos[alumnoIndex] || ""; // Asigna el nombre del alumno o deja la celda en blanco
      }

      // Guardar el libro de Excel
      const excelBuffer = await workbook.xlsx.writeBuffer();
      saveAs(
        new Blob([excelBuffer]),
        `Lista grupo ${datosGrupo.numero_grupo}.xlsx`
      );
    } catch (error) {
      console.error("Error al generar el archivo Excel:", error);
      toast.error("Error al generar el archivo Excel");
    }
  };

  const hasDefinitiveDropout = alumnosOrdenados?.some(
    (alumno) => alumno.estado_alumno === "Egresado"
  );

  return (
    <div>
      {alumnosOrdenados?.length > 0 && !hasDefinitiveDropout && (
        <Button
          icon="file excel"
          content="Lista de grupo"
          onClick={generateListaGrupo}
        />
      )}
      <div className="buscar">
        <Icon name="search" className="bot" />
        <Input
          placeholder="Buscar por nombre"
          value={realTimeSearch}
          onChange={(e) => handleRealTimeSearchChange(e.target.value)}
          style={{ marginTop: "12px" }}
        />
      </div>
      {grupo && <h4>Total de alumnos: {grupo.alumnos.length}</h4>}{" "}
      <Table className="table-users-admin">
        <Table.Header>
          <Table.Row>
            {alumnosOrdenados.some(
              (alumno) => alumno.estado_alumno === "Activo"
            ) && <Table.HeaderCell>NUM. DE LISTA</Table.HeaderCell>}
            <Table.HeaderCell>CURP</Table.HeaderCell>
            <Table.HeaderCell>MATRICULA</Table.HeaderCell>
            <Table.HeaderCell>APELLIDO PATERNO</Table.HeaderCell>
            <Table.HeaderCell>APELLIDO MATERNO</Table.HeaderCell>
            <Table.HeaderCell>NOMBRE</Table.HeaderCell>
            <Table.HeaderCell>SEMESTRE</Table.HeaderCell>
            <Table.HeaderCell>ACCIONES</Table.HeaderCell>
          </Table.Row>
        </Table.Header>

        <Table.Body>
          {paginatedAlumnos
            .sort((a, b) =>
              a.apellido_paterno.localeCompare(b.apellido_paterno)
            )
            .map((alumnoo, index) => (
              <Table.Row key={index}>
                {alumnoo.estado_alumno === "Activo" && (
                  <Table.Cell>{rowIndex + index}</Table.Cell>
                )}
                <Table.Cell>{alumnoo.curp}</Table.Cell>
                <Table.Cell>{alumnoo.matricula}</Table.Cell>
                <Table.Cell>{alumnoo.apellido_paterno}</Table.Cell>
                <Table.Cell>{alumnoo.apellido_materno}</Table.Cell>
                <Table.Cell>{alumnoo.nombre}</Table.Cell>
                <Table.Cell>{alumnoo.semestre}</Table.Cell>
                <Actions
                  alumno={alumnoo}
                  bajaTemporalAlumno={bajaTemporalAlumno}
                  updateAlumno={updateAlumno}
                />
              </Table.Row>
            ))}
        </Table.Body>
      </Table>
      <div style={{ textAlign: "center", marginTop: "10px" }}>
        <Button.Group>
          {Array.from({
            length: Math.ceil(filteredAlumnos().length / itemsPerPage),
          }).map((_, index) => {
            const pageNumber = index + 1;
            const maxVisibleButtons = 4;
            const startPage = Math.max(
              1,
              currentPage - Math.floor(maxVisibleButtons / 2)
            );
            const endPage = Math.min(
              startPage + maxVisibleButtons - 1,
              Math.ceil(filteredAlumnos().length / itemsPerPage)
            );
            const showStartEllipsis = startPage > 1;
            const showEndEllipsis =
              endPage < Math.ceil(filteredAlumnos().length / itemsPerPage);

            // para evitar renderizar el botón si solo hay una página
            if (Math.ceil(filteredAlumnos().length / itemsPerPage) === 1) {
              return null;
            }
            if (pageNumber >= startPage && pageNumber <= endPage) {
              return (
                <Button
                  key={pageNumber}
                  icon
                  active={currentPage === pageNumber}
                  onClick={() => handlePageChange(pageNumber)}
                >
                  {pageNumber}
                </Button>
              );
            } else if (showStartEllipsis && pageNumber === 1) {
              return (
                <Button key="startEllipsis" icon className="bordebotn">
                  {"..."}
                </Button>
              );
            } else if (
              showEndEllipsis &&
              pageNumber === Math.ceil(filteredAlumnos().length / itemsPerPage)
            ) {
              return (
                <Button key="endEllipsis" icon className="bordebotn">
                  {"..."}
                </Button>
              );
            }
            return null;
          })}
        </Button.Group>
      </div>
    </div>
  );
}

function Actions(props) {
  const { alumno, bajaTemporalAlumno, updateAlumno } = props;
  return (
    <Table.Cell textAlign="center">
      <div className="action-buttons">
        {alumno.estado_alumno === "Activo" && (
          <Button
            data-tooltip-id="my-tooltip"
            data-tooltip-content="Actualizar datos alumno"
            icon
            className="yellow"
            onClick={() => {
              updateAlumno(alumno);
            }}
          >
            <Icon name="pencil" style={{ color: "white" }}></Icon>
          </Button>
        )}
        {alumno.estado_alumno === "Activo" && (
          <Button
            data-tooltip-id="my-tooltip"
            data-tooltip-content="Dar de baja"
            icon
            negative
            onClick={() => {
              bajaTemporalAlumno(alumno);
            }}
          >
            <Icon name="minus circle" style={{ color: "white" }}></Icon>
          </Button>
        )}

        {alumno.estado_alumno === "Egresado" && (
          <Button
            data-tooltip-id="my-tooltip"
            data-tooltip-content="Ver datos"
            icon
            onClick={() => {
              updateAlumno(alumno);
            }}
            className="botonEnviar"
          >
            <Icon name="eye" style={{ color: "white" }}></Icon>
          </Button>
        )}
        <Tooltip id="my-tooltip" />
      </div>
    </Table.Cell>
  );
}
